.thoughtsIcon {
    height: var(--mantine-spacing-md);
}

.chevron {
    transition: transform 0.2s ease-in-out;
    transform: rotate(-90deg);
}

.chevronOpen {
    transform: rotate(0deg);
}

.searchItem {
    background-color: var(--mantine-color-gneis-1);
    border-radius: var(--mantine-radius-md);
    padding: 10px;
    margin: var(--mantine-spacing-xs) 0;
    svg {
        color: var(--mantine-color-gneis-3);
    }
}

.gptStreamParserContent,
.searchItem {
    font-size: var(--mantine-font-size-sm);

    * {
        font-size: inherit;
    }
}
